// extracted by mini-css-extract-plugin
export default {"icon":"_1Y9ffRnoBq","small":"_39MVBfVzZH","large":"_2bsnFTA56c","nudgeUp":"_35vPo0w1MM","nudgeDown":"_2n2WXFnmY0"};
    if(module.hot) {
      // 1625219394657
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  